import { render, staticRenderFns } from "./DigitalDetailColumnButton.vue?vue&type=template&id=2eea7ca0&scoped=true&"
import script from "./DigitalDetailColumnButton.vue?vue&type=script&lang=js&"
export * from "./DigitalDetailColumnButton.vue?vue&type=script&lang=js&"
import style0 from "./DigitalDetailColumnButton.vue?vue&type=style&index=0&id=2eea7ca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea7ca0",
  null
  
)

export default component.exports